import { createTranslations } from '@npco/common-utils-translations'

export const transferTypeTabsTranslations = createTranslations({
  bpay: 'BPAY',
  internalTransfer: 'My Accounts',
  contact: 'External Recipients',
  contactMobile: 'External',
})
